<template>
  <div class="breadcrumb" name="breadcrumb">
    <span :key="$route.path" style="">
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: []
    }
  },
  computed: {
    title() {
      if (this.$route.meta.title) {
        return this.$route.meta.title
      }
      return ''
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0]
      if (first && first.name !== '') {
        matched = [{ path: '/index', meta: { title: 'Luxtag' }}].concat(
          matched
        )
      }
      this.levelList = matched
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../styles/variables.scss";
$mobile: 425px;
$tablet: 768px;

.breadcrumb {
  span {
    height: 100%;
    font-size: 20px;
    line-height: 1.8;
    letter-spacing: 0.3px;
    color: $primary !important;
    font-weight: bold !important;
    @media screen and (max-width: $tablet) {
      line-height: 1.2;
    }
    @media screen and (max-width: $mobile) {
      line-height: 1.2;
      font-size: 16px;
    }
  }
}

.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
  .no-redirect {
    color: #000 !important;
    font-weight: bold !important;
    cursor: text;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue